var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c("div", { staticClass: "robot-body" }, [
      _c("div", { staticClass: "tip" }, [
        _vm._v("Hi，我是AI助手小T，我可以为您"),
      ]),
      _c("div", [
        _c(
          "div",
          {
            staticClass: "li fx-s-center",
            staticStyle: { "margin-bottom": "8px" },
            on: { click: _vm.clickRecommendClue },
          },
          [
            _vm._m(1),
            _c("div", { staticClass: "fx-full cls001" }, [_vm._v("推荐线索")]),
            _vm._m(2),
          ]
        ),
        _c(
          "div",
          {
            staticClass: "li fx-s-center",
            staticStyle: { "margin-bottom": "8px" },
            on: { click: _vm.clickSubscribe },
          },
          [
            _vm.unreadCount > 0
              ? _c("i", { staticClass: "red-icon" })
              : _vm._e(),
            _vm._m(3),
            _c("div", { staticClass: "fx-full cls001" }, [_vm._v("商机订阅")]),
            _vm._m(4),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "robot-header fx" }, [
      _c("img", {
        staticStyle: { width: "16px", height: "17px" },
        attrs: { src: require("@/assets/newicons/ib01.png"), alt: "" },
      }),
      _c("span", [_vm._v("小T")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fx-none icon fx-ps-center" }, [
      _c("i", { staticClass: "iconfont icon-zhinengtuijian" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fx-none" }, [
      _c("i", { staticClass: "el-icon-arrow-right" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fx-none icon fx-ps-center" }, [
      _c("i", { staticClass: "iconfont icon-sjdy" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fx-none" }, [
      _c("i", { staticClass: "el-icon-arrow-right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }